/**
 * Méthode qui contrôle un champ en ayant un caractère en upperCase
 * @param value valeur du champ
 * @param hasControle savoir s'il doit être contrôlé
 */
export function controlUpperCase(value: string, hasControle: boolean | undefined) {
    const hasUpperCase = /[A-Z]/.test(value);
    return (hasControle && hasUpperCase) || !hasControle;
}

/**
 * Méthode qui contrôle un champ en ayant un caractère en lowerCase
 * @param value valeur du champ
 * @param hasControle savoir s'il doit être contrôlé
 */
export function controlLowerCase(value: string, hasControle: boolean | undefined) {
    const hasLowerCase = /[a-z]/.test(value);
    return (hasControle && hasLowerCase) || !hasControle;
}

/**
 * Méthode qui contrôle un champ en ayant un caractère en numeric
 * @param value valeur du champ
 * @param hasControle savoir s'il doit être contrôlé
 */
export function controlNumeric(value: string, hasControle: boolean | undefined) {
    const hasNumber = /\d/.test(value);
    return (hasControle && hasNumber) || !hasControle;
}

/**
 * Méthode qui contrôle un champ en ayant un caractère special
 * @param value valeur du champ
 * @param hasControle savoir s'il doit être contrôlé
 */
export function controlSpecific(value: string, hasControle: boolean | undefined) {
    const hasSymbole = /[!@#%&]/.test(value);
    return (hasControle && hasSymbole) || !hasControle;
}

/**
 * Méthode qui contrôle un champ sur sa taille
 * @param value valeur du champ
 * @param minLength taille min
 */
export function controlLengthMin(value: string, minLength: number | undefined) {
    const length = value.length;
    return (minLength && length >= minLength) || !minLength;
}

/**
 * Méthode qui contrôle un champ sur sa taille
 * @param value valeur du champ
 * @param maxLength taille max
 */
export function controlLengthMax(value: string, maxLength: number | undefined) {
    const length = value.length;
    return (maxLength && length <= maxLength) || !maxLength;
}

/**
 * Méthode vérifiant si la date de naissance entrée correspond bien à l'âge de 16 ans
 * @param value Date de naissance
 */
export function verifyAge(value: string) {
    const birthday = Date.parse(value);
    const now = new Date();
    const requiredAge = 16;
    const msToYearDivision = 31557600000;
    return Math.floor((now.getTime() - birthday) / msToYearDivision) >= requiredAge;
}
